// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as SupplierRoutes from "../../app/Supplier/SupplierRoutes.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query SuppliersQuery($filterBy: InputSuppliersQueryFilter, $after: String, $first: Int)  {\nsuppliers(filterBy: $filterBy, after: $after, first: $first)  {\n__typename  \npageInfo  {\n__typename  \nendCursor  \nhasNextPage  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \ncompanyName  \n}\n\n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.suppliers;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.endCursor;
  let value$4 = value$2.hasNextPage;
  let value$5 = value$1.edges;
  return {
    suppliers: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        endCursor: !(value$3 == null) ? value$3 : undefined,
        hasNextPage: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            companyName: value$1.companyName
          }
        };
      })
    }
  };
}

function serialize(value) {
  let value$1 = value.suppliers;
  let value$2 = value$1.edges;
  let edges = value$2.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.companyName;
    let value$3 = value$1.id;
    let value$4 = value$1.__typename;
    let node = {
      __typename: value$4,
      id: value$3,
      companyName: value$2
    };
    let value$5 = value.__typename;
    return {
      __typename: value$5,
      node: node
    };
  });
  let value$3 = value$1.pageInfo;
  let value$4 = value$3.hasNextPage;
  let hasNextPage = value$4 !== undefined ? value$4 : null;
  let value$5 = value$3.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$3.__typename;
  let pageInfo = {
    __typename: value$6,
    endCursor: endCursor,
    hasNextPage: hasNextPage
  };
  let value$7 = value$1.__typename;
  let suppliers = {
    __typename: value$7,
    pageInfo: pageInfo,
    edges: edges
  };
  return {
    suppliers: suppliers
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputSuppliersQueryFilter(inp) {
  let a = inp.archived;
  let a$1 = inp.shopIds;
  return {
    archived: a !== undefined ? (
        a === "ONLY" ? "ONLY" : (
            a === "INCLUDED" ? "INCLUDED" : "EXCLUDED"
          )
      ) : undefined,
    shopIds: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.filterBy;
  let a$1 = inp.after;
  let a$2 = inp.first;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputSuppliersQueryFilter(a) : undefined,
    after: a$1 !== undefined ? a$1 : undefined,
    first: a$2 !== undefined ? a$2 : undefined
  };
}

function makeVariables(filterBy, after, first) {
  return {
    filterBy: filterBy,
    after: after,
    first: first
  };
}

function makeInputObjectInputSuppliersQueryFilter(archived, shopIds, param) {
  return {
    archived: archived,
    shopIds: shopIds
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeDefaultVariables() {
  return {
    filterBy: undefined,
    after: undefined,
    first: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSuppliersQueryFilter: serializeInputObjectInputSuppliersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputSuppliersQueryFilter: makeInputObjectInputSuppliersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_use = include.use;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputSuppliersQueryFilter: serializeInputObjectInputSuppliersQueryFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  makeVariables: makeVariables,
  makeInputObjectInputSuppliersQueryFilter: makeInputObjectInputSuppliersQueryFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: Query_use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function paginateSuppliersQueryFn(apolloClient, shopId, after, dataOpt, param) {
  let data = dataOpt !== undefined ? dataOpt : [];
  return Future.flatMapOk(Future.mapError(FuturePromise.fromPromise(apolloClient.rescript_query({
    query: query,
    Raw: Raw,
    parse: parse,
    serialize: serialize,
    serializeVariables: serializeVariables
  }, undefined, undefined, "NetworkOnly", undefined, {
    filterBy: {
      archived: "EXCLUDED",
      shopIds: shopId !== undefined ? ({
          _in: [shopId]
        }) : undefined
    },
    after: after,
    first: 50
  })), undefined, param => {}), undefined, response => {
    if (response.TAG !== "Ok") {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    }
    let match = response._0;
    let match$1 = match.data.suppliers;
    let match$2 = match$1.pageInfo;
    let match$3 = match$2.hasNextPage;
    if (match$3 !== undefined && match$3) {
      if (match.error !== undefined) {
        return Future.value({
          TAG: "Error",
          _0: undefined
        });
      } else {
        return paginateSuppliersQueryFn(apolloClient, shopId, match$2.endCursor, data.concat(match$1.edges), undefined);
      }
    }
    if (match.error !== undefined) {
      return Future.value({
        TAG: "Error",
        _0: undefined
      });
    } else {
      return Future.value({
        TAG: "Ok",
        _0: data.concat(match$1.edges)
      });
    }
  });
}

function useSuppliersQuery(paginateSuppliersQuery, shopId) {
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = React.useState(() => "Loading");
  let setSuppliers = match[1];
  React.useEffect(() => {
    if (Stdlib_Option.isSome(shopId)) {
      setSuppliers(value => {
        if (typeof value !== "object") {
          return "Loading";
        } else {
          return {
            TAG: "Reloading",
            _0: value._0
          };
        }
      });
      Future.tapOk(paginateSuppliersQuery(apolloClient, shopId, undefined, undefined, undefined), suppliers => setSuppliers(param => ({
        TAG: "Done",
        _0: suppliers
      })));
    }
  }, [shopId]);
  return match[0];
}

function SupplierSelect(props) {
  let onDismiss = props.onDismiss;
  let onChange = props.onChange;
  let value = props.value;
  let __paginateSuppliersQuery = props.paginateSuppliersQuery;
  let shopId = props.shopId;
  let __hideOverlayFooter = props.hideOverlayFooter;
  let __showDefaultItems = props.showDefaultItems;
  let showDefaultItems = __showDefaultItems !== undefined ? __showDefaultItems : false;
  let hideOverlayFooter = __hideOverlayFooter !== undefined ? __hideOverlayFooter : false;
  let paginateSuppliersQuery = __paginateSuppliersQuery !== undefined ? __paginateSuppliersQuery : paginateSuppliersQueryFn;
  let queryResult = useSuppliersQuery(paginateSuppliersQuery, shopId);
  let suppliersResult = AsyncData.map(queryResult, suppliers => suppliers.map(supplier => ({
    id: supplier.node.id,
    name: supplier.node.companyName
  })));
  let suppliers;
  suppliers = typeof suppliersResult !== "object" ? (
      suppliersResult === "NotAsked" ? [] : []
    ) : suppliersResult._0;
  let supplierKey = supplier => Stdlib_Option.getOr(Primitive_option.fromNullable(supplier.id), supplier.name);
  let items;
  let exit = 0;
  exit = typeof suppliersResult !== "object" ? 2 : 1;
  switch (exit) {
    case 1 :
      items = suppliersResult._0.map(supplier => ({
        TAG: "Option",
        key: supplierKey(supplier),
        label: supplier.name,
        value: Primitive_option.some(supplier.id)
      }));
      break;
    case 2 :
      items = Stdlib_Option.mapOr(value, [], supplier => [{
          TAG: "Option",
          key: supplierKey(supplier),
          label: supplier.name,
          value: Primitive_option.some(supplier.id)
        }]);
      break;
  }
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "__all__",
    label: defaultItem_1,
    value: undefined,
    exclusive: defaultItem_4
  };
  let notSpecifiedItem_1 = I18n.template(I18n.t("Not specified"), undefined, undefined);
  let notSpecifiedItem_2 = null;
  let notSpecifiedItem_4 = true;
  let notSpecifiedItem = {
    TAG: "Option",
    key: "__not-specified__",
    label: notSpecifiedItem_1,
    value: notSpecifiedItem_2,
    exclusive: notSpecifiedItem_4
  };
  let sections = showDefaultItems ? [
      {
        items: [
          defaultItem,
          notSpecifiedItem
        ]
      },
      {
        items: items,
        title: I18n.t("Suppliers")
      }
    ] : [{
        items: items
      }];
  let onSelectionChange = selection => {
    if (selection.TAG !== "Single") {
      return;
    }
    let id = selection._0;
    if (id === undefined) {
      return onChange(undefined);
    }
    let id$1 = Primitive_option.valFromOption(id);
    if (id$1 == null) {
      return onChange({
        id: null,
        name: I18n.t("Not specified")
      });
    }
    let name = Stdlib_Option.mapOr(suppliers.find(supplier => Primitive_object.equal(Primitive_option.fromNullable(supplier.id), id$1)), "", supplier => supplier.name);
    onChange({
      id: id$1,
      name: name
    });
  };
  ReactUpdateEffect.use1(() => {
    if (value !== undefined && typeof suppliersResult === "object" && suppliersResult.TAG === "Done") {
      let selectedSupplierNotFound = suppliersResult._0.every(current => current.id !== value.id) && !(value.id == null);
      if (selectedSupplierNotFound) {
        onChange(undefined);
      }
    }
  }, [AsyncData.isBusy(suppliersResult)]);
  let onToggle = React.useCallback(opened => {
    if (opened || onDismiss === undefined) {
      return;
    } else {
      return onDismiss();
    }
  }, []);
  let loading = AsyncData.isBusy(suppliersResult);
  let disabled = Stdlib_Option.isNone(shopId);
  let footerElement = hideOverlayFooter ? undefined : JsxRuntime.jsx(Select.FooterAction.make, {
      label: I18n.t("Create supplier"),
      href: SupplierRoutes.newRoute(shopId, undefined),
      target: "_blank"
    });
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Select.make, {
      label: props.label,
      placeholder: I18n.t("Select a supplier"),
      preset: props.preset,
      size: props.size,
      defaultOpen: props.defaultOpen,
      disabled: disabled,
      loading: loading,
      onToggle: onToggle,
      footerElement: footerElement,
      sections: sections,
      value: {
        TAG: "Single",
        _0: Stdlib_Option.map(value, supplier => supplier.id)
      },
      onChange: onSelectionChange
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: I18n.t("Please select a shop beforehand.")
    }),
    disabled: !disabled,
    delay: 350
  });
}

let make = React.memo(SupplierSelect);

export {
  Query,
  paginateSuppliersQueryFn,
  useSuppliersQuery,
  make,
}
/* query Not a pure module */
